import { compose, applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import statusesReducerCreator, { STATUSES_STATE_SLICE } from '@cld/statuses-reducer';
import { combineReducers } from './reducers';
import { WindowExtended } from './types';

const enhancers = [];
const middlewareChain = [];

if (process.env.NODE_ENV !== 'production' && window && (window as unknown as WindowExtended).__REDUX_DEVTOOLS_EXTENSION__) {
  enhancers.push((window as unknown as WindowExtended).__REDUX_DEVTOOLS_EXTENSION__());
}

if (process.env.NODE_ENV !== 'production') {
  middlewareChain.unshift(createLogger({ collapsed: true }));
}

const composedEnhancers = compose(applyMiddleware(...middlewareChain), ...enhancers);

export const store = createStore(
  combineReducers({
    [STATUSES_STATE_SLICE]: statusesReducerCreator(),
  }),
  composedEnhancers
);

export default store;
